function TextChanger() {
  return {
    interval: 4000,
    replacements: [],
    activeIndex: 0,
    reduceMotion: false,
    isLarge: false,

    startAnimation() {
      setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.replacements.length;
      }, this.interval);
    },

    init({ replacements = [], interval }) {
      this.interval = interval;
      this.replacements = replacements;

      // const motionMediaQuery = window.matchMedia(
      //   '(prefers-reduced-motion: reduce)'
      // );
      // motionMediaQuery.addEventListener('change', event => {
      //   this.reduceMotion = event.matches;
      //   if (!event.matches) {
      //     this.startAnimation();
      //   }
      // });

      // const sizeMediaQuery = window.matchMedia(
      //   `(min-width: ${breakpoints.md})`
      // );
      // sizeMediaQuery.addEventListener('change', event => {
      //   this.isLarge = event.matches;
      //   if (event.matches) {
      //     this.startAnimation();
      //   }
      // });

      if (this.replacements.length > 1 && this.isLarge && !this.reduceMotion) {
        this.startAnimation();
      }
    },
  };
}

export default TextChanger;
